<script setup lang="ts">
import type { WelfareBrandCollectionItem } from '@nuxt/content'

const props = defineProps<{
  welfareBrandKey: WelfareBrandCollectionItem['key']
}>()

const { data: welfareBrands } = await useWelfareBrands()

const welfareBrand = computed<WelfareBrandCollectionItem>(() => {
  const noBrand = {
    id: '',
    label: '',
    subLabel: '',
  } as WelfareBrandCollectionItem

  return welfareBrands.value.find(brand => brand.key === props.welfareBrandKey) ?? noBrand
})
</script>

<template>
  <div v-if="welfareBrand" class="flex-nowrap text-nowrap flex gap-1 border dark:border-neutral-600 dark:bg-neutral-900 dark:text-neutral-300 rounded px-1.5 py-0.5 text-[.76rem]">
    <span>{{ welfareBrand.label }}</span>
    <span v-if="welfareBrand.subLabel" class="dark:text-primary-300 text-primary-600">{{ welfareBrand.subLabel }}</span>
  </div>
</template>
